import { useImmerAtom } from 'jotai-immer';
import { TblCol, TblView } from '../../../../core/table/table.types';
import { tableUsageViewAtom } from '../../list/provider_list_atoms';
import { useEffect } from 'react';
import { providerUsageListColumnSpec } from './ProviderUsageTableSpec';

export const useProviderUsageListTableView = (): TblView => {
    const [view, setView] = useImmerAtom(tableUsageViewAtom);

    useEffect(() => {
        setView(draft => {
            const columns: TblCol[] = [];
            providerUsageListColumnSpec().forEach(col => {
                columns.push(col);
            });

            draft.cols = columns;
        });
    }, [setView]);

    return {
        cols: view.cols,
        sections: view.sections,
        sort: view.sort,
    };
};
